const vacancyFilters = document.querySelector('[data-vacancy-filters]');

if (vacancyFilters) {
    const url = new URL(window.location.href);
    const selects = vacancyFilters.querySelectorAll('select[data-filter]');
    const grid = document.querySelector('[data-vacancy-grid]');
    const countElement = document.querySelector('[data-vacancy-count]');
    const noResultsElement = document.querySelector('[data-no-results]');
    const activeFiltersContainer = document.querySelector('[data-active-filters]');
    const resetBtns = document.querySelectorAll('[data-reset-filters]');
    const removeFilterBtns = document.querySelectorAll('[data-remove-filter]');

    const updateUrlAndFilter = () => {
        selects.forEach((select) => {
            const filterName = select.dataset.filter;
            const value = select.value;

            if (value) {
                url.searchParams.set(filterName, value);
            } else {
                url.searchParams.delete(filterName);
            }
        });

        window.history.replaceState({}, '', url.toString());
        filterVacancies();
    };

    const filterVacancies = () => {
        if (!grid) return;

        const cards = grid.querySelectorAll('article.vacancy-card');
        const locationFilter = (url.searchParams.get('locatie') || '').toLowerCase();
        const departmentFilter = (url.searchParams.get('afdeling') || '').toLowerCase();
        const contractFilter = (url.searchParams.get('contract_type') || '').toLowerCase();

        let visibleCount = 0;

        cards.forEach((card) => {
            const cardLocation = card.dataset.location || '';
            const cardDepartment = card.dataset.department || '';
            const cardContractType = card.dataset.contractType || '';

            const matchesLocation = !locationFilter || cardLocation === locationFilter;
            const matchesDepartment = !departmentFilter || cardDepartment === departmentFilter;

            const matchesContract = !contractFilter ||
                cardContractType === contractFilter ||
                cardContractType === 'both';

            const isVisible = matchesLocation && matchesDepartment && matchesContract;

            if (isVisible) {
                card.classList.remove('vacancy-card--hidden');
                visibleCount++;
            } else {
                card.classList.add('vacancy-card--hidden');
            }
        });

        if (countElement) {
            countElement.textContent = countElement.textContent.replace(/\d+/, visibleCount);
        }

        if (noResultsElement) {
            noResultsElement.style.display = visibleCount === 0 ? '' : 'none';
        }

        updateActiveFilters();
    };

    const getSelectedLabel = (select) => {
        return select?.selectedOptions[0]?.text || '';
    };

    const updateActiveFilters = () => {
        if (!activeFiltersContainer) return;

        const locationFilter = url.searchParams.get('locatie') || '';
        const departmentFilter = url.searchParams.get('afdeling') || '';
        const contractFilter = url.searchParams.get('contract_type') || '';

        const locationSelect = vacancyFilters.querySelector('select[data-filter="locatie"]');
        const departmentSelect = vacancyFilters.querySelector('select[data-filter="afdeling"]');
        const contractSelect = vacancyFilters.querySelector('select[data-filter="contract_type"]');

        const locationBtn = document.querySelector('[data-remove-filter="locatie"]');
        const departmentBtn = document.querySelector('[data-remove-filter="afdeling"]');
        const contractBtn = document.querySelector('[data-remove-filter="contract_type"]');

        if (locationBtn) {
            locationBtn.style.display = locationFilter ? '' : 'none';
            const textNode = locationBtn.lastChild;
            if (textNode) textNode.textContent = locationFilter ? getSelectedLabel(locationSelect) : '';
        }

        if (departmentBtn) {
            departmentBtn.style.display = departmentFilter ? '' : 'none';
            const textNode = departmentBtn.lastChild;
            if (textNode) textNode.textContent = departmentFilter ? getSelectedLabel(departmentSelect) : '';
        }

        if (contractBtn) {
            contractBtn.style.display = contractFilter ? '' : 'none';
            const textNode = contractBtn.lastChild;
            if (textNode) textNode.textContent = contractFilter ? getSelectedLabel(contractSelect) : '';
        }

        const hasFilters = locationFilter || departmentFilter || contractFilter;
        activeFiltersContainer.style.display = hasFilters ? '' : 'none';

        resetBtns.forEach(btn => {
            btn.style.display = hasFilters ? '' : 'none';
        });
    };

    const removeFilter = (filterName) => {
        url.searchParams.delete(filterName);

        const select = vacancyFilters.querySelector(`select[data-filter="${filterName}"]`);
        if (select) select.value = '';

        window.history.replaceState({}, '', url.toString());
        filterVacancies();

        const filterBtn = document.querySelector(`[data-remove-filter="${filterName}"]`);
        if (filterBtn) filterBtn.style.display = 'none';
    };

    const resetFilters = () => {
        url.searchParams.delete('locatie');
        url.searchParams.delete('afdeling');
        url.searchParams.delete('contract_type');

        selects.forEach((select) => {
            select.value = '';
        });

        window.history.replaceState({}, '', url.toString());
        filterVacancies();

        removeFilterBtns.forEach(btn => btn.style.display = 'none');
    };

    selects.forEach((select) => {
        select.addEventListener('change', updateUrlAndFilter);
    });

    resetBtns.forEach((btn) => {
        btn.addEventListener('click', resetFilters);
    });

    removeFilterBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            removeFilter(btn.dataset.removeFilter);
        });
    });

    filterVacancies();
}

